module.exports = {"350205001":"海沧街道","350205002":"新阳街道","350205003":"嵩屿街道","350205004":"东孚街道","350205403":"天竺山林场","350205407":"厦门海沧保税港区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350205.json
// module id = 1284
// module chunks = 0